import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";
import { ErrorDialogContext } from "src/components/common/dialogs/errorDialog/ErrorDialogProvider.tsx";

export const useErrorDialog = () => useContextOrThrow(ErrorDialogContext);
